class CheckPaymentOptions {
    constructor(element, options) {
        this._element = element;
        this._options = options;

        this.init();
    }

    init() {
        this._cacheSelectors();
        this._bindEvents();
        this._handleApprovalConsent();
    }

    _cacheSelectors() {
        const querySelector = this._element.querySelector.bind(this._element);

        this._elements = {
            IBAN: querySelector('[data-payment-iban]'),
            paymentApproval: querySelector('[data-payment-approval]'),
            paymentOptions: this._element.querySelectorAll('[data-payment-option]')
        };
    }

    _bindEvents() {
        const {IBAN, paymentOptions} = this._elements;

        // IBAN check
        if (IBAN) {
            IBAN.addEventListener('blur', this._handleApprovalConsent.bind(this));
        }

        // Payment method options
        if (paymentOptions) {
            [...paymentOptions].forEach(element => {
                element.addEventListener("change", this._handleApprovalConsent.bind(this));
            });
        }
    }

    /**
     * Handle approval
     */
    _handleApprovalConsent() {
        const {paymentOptions, IBAN} = this._elements;
        const hasMethodDirectDebt = paymentOptions && this._hasMethodDirectDebt(paymentOptions);
        const hasChangedIBAN = IBAN && this._hasChangedIBAN(IBAN);

        this._toggleApprovalConsent(hasMethodDirectDebt || hasChangedIBAN);
    }

    /**
     * Check if IBAN has changed from initial value
     * @param element
     * @returns {boolean}
     */
    _hasChangedIBAN(element) {
        const { IBAN } = this._elements;
        let IBANInitialValue = '';

        if(IBAN.dataset.paymentInitialValue && IBAN.dataset.paymentInitialValue !== '') {
            IBANInitialValue = IBAN.dataset.paymentInitialValue;
        }

        return element.value !== IBANInitialValue;
    }

    /**
     * Check if:
     * 1. An [element] has intial value Direct Debt
     * 2. Else check if [element] has changed to Direct Debt and is different from initial value.
     * @param elements
     * @returns {boolean}
     */
    _hasMethodDirectDebt(elements) {
        const directDebtLabel = 'Automatische incasso';
        const giroCardLabel = 'Acceptgiro';
        const hasInitialValueGiroCard = [...elements].find(item => item.dataset.paymentInitialValue === giroCardLabel);

        if(hasInitialValueGiroCard) {
            const hasValueToDirectDebt = [...elements].find(input =>
                input.value === directDebtLabel &&
                input.checked &&
                input.dataset.paymentInitialValue !== directDebtLabel
            );

            return !!hasValueToDirectDebt;
        }

        return false
    }

    /**
     * Show or hide the Agreement content for Direct Debt
     * @param value
     */
    _toggleApprovalConsent(value) {
        const {paymentApproval} = this._elements;

        value ? paymentApproval.classList.remove("is-hidden") : paymentApproval.classList.add("is-hidden");
    }
}
